// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"PeriodicList_wrapperComponent__Yy+cA"};